import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import infoIcon from "icons/info-new-rows.svg";
import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { setAnonymizeUsers } from "slices/systemAdmin/actions/systemAdmin";

const AnonymiseUsersModal = () => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.ANONYMIZE_USERS));
  };

  const handleSave = () => {
    dispatch(setAnonymizeUsers(true));
  };

  const modalBody = () => (
    <div className="anonymize__users__modal">
      <div className="anonymize__users__modal__icon">
        <img src={infoIcon} alt="info icon" />
      </div>
      <div className="anonymize__users__modal__info">
        <p>
          Turning this setting on will anonymize each user’s username in Usage
          Reports. This affects all workspaces. Do you wish to proceed?
        </p>
      </div>
    </div>
  );

  return (
    <Modal
      data-testid="anonymizeUsersModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
    >
      <Modal.Header>
        <b>Anonymize Users</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <NewButton
          onClick={handleCancel}
          variant={NewButtonVariant.l2}
          data-test="cancelButton"
          disabled={false}
        >
          Cancel
        </NewButton>

        <NewButton
          onClick={handleSave}
          variant={NewButtonVariant.l1}
          data-test="saveButton"
          disabled={false}
        >
          Anonymize Users
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AnonymiseUsersModal;
